/** 装箱操作路由 */
export default{
    name: 'boxing',
    path: 'boxing',
    meta: {title: '装箱操作管理'},
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'boxing-generate',
            path: 'generate',
            meta: { title: '生成外箱码' },
            component: ()=>import('@/pages/boxing/generate.vue')
        },
        {
            name: 'boxing-intelligence',
            path: 'intelligence',
            meta: { title: '智能批量装箱' },
            component: ()=>import('@/pages/boxing/intelligence.vue')
        },
        {
            name: 'boxing-smallbox',
            path: 'smallbox',
            meta: { title: '产品装小箱管理' },
            component: ()=>import('@/pages/boxing/smallbox.vue')
        },
        {
            name: 'boxing-largebox',
            path: 'largebox',
            meta: { title: '小箱装大箱管理' },
            component: ()=>import('@/pages/boxing/largebox.vue')
        },
        {
            name: 'boxing-unboxing',
            path: 'unboxing',
            meta: { title: '拆箱管理' },
            component: ()=>import('@/pages/boxing/unboxing.vue')
        },
        {
            name: 'boxing-journal',
            path: 'journal',
            meta: { title: '装箱操作日志' },
            component: ()=>import('@/pages/boxing/journal.vue')
        }
    ]
}
